module.exports = __webpack_public_path__ + "img/oval-red.c350a5e5.svg";